import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Hr.module.sass';

const Hr = ({ content, classes }) => {
  return (
    <div className={cn(styles.hr, classes)} data-content={content}></div>
  );
};

Hr.propTypes = {
  content: PropTypes.string,
  classes: PropTypes.string,
};

export default Hr;
